
import { connect } from 'react-redux';
import { container } from 'op/container';
import { compose, withProps, withHandlers, withState, lifecycle, defaultProps } from 'recompose';

import { withTypes, withCategories } from 'op/components/lut';

export const withReportMetadata = compose(
	defaultProps({
		readOnly: [],
	}),
	connect(({ person }, { report }) => ({
		person: person.loaded.find(p => p.id === report.person_id),
	})),
	withTypes,
	withCategories,
	withHandlers({
		setType: ({ setCategories, fetchCategories, invokeChange }) => (type) => {
			fetchCategories(type.id);
			invokeChange({ 
				type: { $set: type },
				category: { $set: null },
			});
		}
	}),
	withProps(({ types }) => ({
		ready: types.length !== 0,
	})),
	lifecycle({
		async componentDidMount() {
			const { online, types, report, fetchTypes, fetchCategories } = this.props;

			if(online){
				await fetchTypes();

				if (report.type && report.type.id) {
					await fetchCategories(report.type.id);
				}
			}
		}
	}),
);
